import type { HeartbeatProps } from '@atlassian/heartbeat/types';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const BaseHeartbeatLoadable: LoadableType<HeartbeatProps> = LoadableLazy({
	loader: async () =>
		await import(/* webpackChunkName: "loadable-atlassianheartbeat" */ '@atlassian/heartbeat'),
});
